import { QuoteActivityService } from "@common/client"
import { makeQuery } from "../utils"

export const quoteActivityBaseKey = ["quote-activity"] as const

export const quoteActivityKey = (quoteId: string) =>
  [...quoteActivityBaseKey, quoteId] as const

export const quoteActivityQuery = makeQuery({
  serviceCall: QuoteActivityService.listActivity,
  queryKey: (params) => quoteActivityKey(params.quote_id),
})
